import clsx from 'clsx';
import { createContext, useContext, useState } from 'react';

import { Breadcrumbs, DrawerContext, SelectorContainer } from '@/components';
import { SIDE_NAVIGATION_MENU } from '@/globalConsts';
import { trackEvent } from '@/lib/analytics';

type TableViewProps = {
	children: React.ReactElement;
	selectorType: 'study' | 'Trial Site' | 'Study and survey';
};

type StateType = boolean;

type SelectorContextType = {
	isExpanded: StateType;
	selectorType: 'study' | 'Trial Site' | 'Study and survey';
};

export const SelectorContext = createContext<SelectorContextType>({} as SelectorContextType);

export const TableView = (props: TableViewProps) => {
	const { children, selectorType } = props;
	const [isExpanded, setIsExpanded] = useState<StateType>(true);
	const { isOpen } = useContext(DrawerContext);

	const toggleSelector = () => {
		setIsExpanded(!isExpanded);
		const options = { isExpanded: !isExpanded };
		trackEvent('Selector display toggled', options);
	};

	const value = { isExpanded, selectorType };

	return (
		<SelectorContext.Provider value={value}>
			<div className='flex flex-row justify-start items-start w-full'>
				<SelectorContainer type={selectorType} handleClick={toggleSelector} />
				<div
					className={clsx(
						'transition-padding ease-linear pt-6 pb-4 duration-300',
						isOpen
							? `${SIDE_NAVIGATION_MENU.CALCULATED_WIDTH_VIEW.EXPANDED}`
							: `${SIDE_NAVIGATION_MENU.CALCULATED_WIDTH_VIEW.DEFAULT}`,
						isExpanded ? 'pl-60' : 'pl-6'
					)}
				>
					<Breadcrumbs />
					{children}
				</div>
			</div>
		</SelectorContext.Provider>
	);
};
